import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/Auth";
export var PublicRoute = function (_a) {
    var children = _a.children;
    var _b = useAuth().userTokens, token = _b.token, tokenDB = _b.tokenDB;
    return _jsx(_Fragment, { children: token && tokenDB ? _jsx(Navigate, { to: "/" }, void 0) : children }, void 0);
};
